// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.st-update-password-container {
    font-family: Arial, Helvetica, sans-serif;
}

.st-password-text-container {
    width: 20%;
    margin-top: 20px;
    margin-left: 10px;
}

.st-submit-button {
    width: 10%;
    margin-top: 20px;
    margin-left: 10px;
}

.st-submit-button.hover {
    background-color: green;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/UpdatePassword.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".st-update-password-container {\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.st-password-text-container {\n    width: 20%;\n    margin-top: 20px;\n    margin-left: 10px;\n}\n\n.st-submit-button {\n    width: 10%;\n    margin-top: 20px;\n    margin-left: 10px;\n}\n\n.st-submit-button.hover {\n    background-color: green;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
